// ======================================================================
// File Name       : AttributeQuestion
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, FormControl, Col, InputGroup, Button } from 'react-bootstrap';
import Datetime from 'react-datetime';
import SelectBox from '../../components/SelectBox';
import { VALIDATE_TYPE, NUM_ATTRIBUTE_QUESTION_SEARCH_MAX } from '../../constants/index';
import FormControlValidate from '../FormControlValidate';
import RenderField from '../../utils/ReduxFormUtils';
import { createAttributeQuestionOptions, createAttributionList } from '../../utils/ContentQuestionUtils';

class AttributeQuestion extends React.Component {
  render() {
    const {
      keyOptions,
      keyText,
      handleChangeOption,
      formValues,
      attributeOptions,
      attributeText,
      attributeListData,
      addAttribute,
      number,
      removeAttributeSearch,
      keyDelete,
    } = this.props;
    let isDisableAddAttribute = false;
    if (number === NUM_ATTRIBUTE_QUESTION_SEARCH_MAX) {
      isDisableAddAttribute = true;
    }
    let data = [{ name: null, value: null }];
    if (
      attributeListData &&
      attributeListData.allSecernIds &&
      attributeListData.allSecernIds.length &&
      attributeListData.bySecernId
    ) {
      data = createAttributeQuestionOptions(attributeListData.allSecernIds, attributeListData.bySecernId);
    }
    const userAttributeList = createAttributionList(number);
    const userAttributeView = userAttributeList.map((attribute, index) => {
      let valueSelectBox = '';
      if (attributeOptions && attribute && attributeOptions[attribute]) {
        valueSelectBox = attributeOptions[attribute];
      }
      
      return (
        <Form.Group className="form-info" key={index}>
          <Col as={Form.Label} sm={3} className="padding-attribute">
            検索属性{index + 1}
          </Col>
          <Col sm={3}>
            <RenderField
              data={data}
              name={`${keyOptions}.${attribute}`}
              type="selectbox"
              handleChangeOption={handleChangeOption}
            />
          </Col>
          <Col sm={4} className="padding-left-15">
            <RenderField 
              name={`${keyText}.${attribute}`}
              disabled={valueSelectBox ? false : true}
            />
          </Col>
          <Col as={Form.Label} sm={2}>
            { index > 4 &&
              <i
                role="button"
                onClick={() => {
                  removeAttributeSearch(`${keyDelete}.${attribute}`);
                }}
                className="bi bi-trash margin-top-10"
                name={`${keyDelete}.${attribute}`}
              />
            }
          </Col>
        </Form.Group>
      );
    });
    return (
      <div> {userAttributeView}
        <Form.Group>
          <Col sm={12} className="padding-left-15 margin-top-10">
            <Button variant="primary" disabled={isDisableAddAttribute} onClick={addAttribute}>
            検索属性追加
            </Button>
          </Col>
        </Form.Group>
      </div>
    );
  }
}

export default AttributeQuestion;
